/* Estado de carga para 'Comprar ahora' (ago-2026).
   El boton unbranded de dynamic checkout navega al checkout sin mostrar
   ninguna senal de progreso; en conexiones lentas eso son 2-5s de silencio
   (Clarity: 175 dead clicks/semana). Solo aplica al boton unbranded: los
   wallets (Shop Pay, etc.) abren su propio panel y no deben tocarse. */
(function () {
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.shopify-payment-button__button--unbranded');
      if (!btn || btn.disabled || btn.classList.contains('mp-loading')) return;
      btn.classList.add('mp-loading');
      // Red de seguridad: si en 8s no navego (error, popup bloqueado), se restaura.
      setTimeout(function () {
        btn.classList.remove('mp-loading');
      }, 8000);
    },
    true
  );
})();
